function sortList(ul){
    var new_ul = ul.cloneNode(false);
    const attr = ul.querySelector('[data-distance]:not([data-distance=""])') ? 'data-distance' : 'data-address';

    // Add all lis to an array
    var lis = [];
    for(var i = ul.childNodes.length; i--;){
        if(ul.childNodes[i].nodeName === 'LI')
            lis.push(ul.childNodes[i]);
    }

    // Sort the lis
    lis.sort(function(a, b){
        if (a.getAttribute(attr) < b.getAttribute(attr)) return -1;
        else if (a.getAttribute(attr) > b.getAttribute(attr)) return 1;
        else return 0;
    });

    // Add them into the ul in order
    for(var i = 0; i < lis.length; i++)
        new_ul.appendChild(lis[i]);
    ul.parentNode.replaceChild(new_ul, ul);
}

const mapLocations = (fetchedLocations, wrapper, input) => {
    //reset
    wrapper.querySelectorAll(".shown").forEach((el) => {
        el.classList.remove('shown');
        el.setAttribute("aria-hidden", "true");
        el.dataset.distance = '';
    });

    //filter fetched locations
    const udp_locations_msg = wrapper.querySelector(".udp-locations-msg");
    const udp_locations_list = wrapper.querySelector(".udp-locations-list");
    if (fetchedLocations.length) {
        fetchedLocations.forEach((location) => {
            const location_li = wrapper.querySelector("[data-placeid='" + location.place_id + "']");
            location_li.classList.add("shown");
            location_li.setAttribute("aria-hidden", "false");
            if (location.distance) location_li.dataset.distance = location.distance;
        });

        //messaging
        if (fetchedLocations.length < wrapper.querySelectorAll("li").length) {
            udp_locations_msg.innerHTML = "(Filtered Search Results)";
            udp_locations_msg.classList.add("shown");
            udp_locations_msg.setAttribute("aria-hidden", "true");
        }
    }
    else {
        udp_locations_msg.innerHTML = "No locations found.";
        udp_locations_msg.classList.add("shown");
        udp_locations_msg.setAttribute("aria-hidden", "true");
    }

    //sort list
    sortList(udp_locations_list);
};

export default mapLocations;